import React from "react";

const PHONE_DISPLAY = "(732) 619-6299";
const PHONE_LINK = "+17326196299";
const EMAIL = "nirhatuka@yahoo.com";

const COORDINATOR_NAME = "Cristina";
const COORDINATOR_PHONE_DISPLAY = "(732) 640-7602";
const COORDINATOR_PHONE_LINK = "+17326407602";
const COORDINATOR_EMAIL = "cristina7811@gmail.com";

const services = [
  {
    title: "Bathroom Remodeling",
    text: "Complete bathroom renovations, from demolition and layout changes to tile, fixtures, showers, vanities, and finishing details.",
    image: "/images/projects/bath-10-amazing.jpeg"
  },
  {
    title: "Custom Tile Installation",
    text: "Precision tile installation for bathroom floors, shower walls, feature walls, foyers, and other interior tile applications.",
    image: "/images/projects/shower-13-wall-good.JPG"
  },
  {
    title: "Shower & Tub Renovations",
    text: "Custom shower surrounds, niches, waterproofing systems, tub surrounds, and modern tile upgrades.",
    image: "/images/projects/shower-05-amazing-with-glass-door.jpeg"
  }
];

const galleryProjects = [
  {
    src: "/images/projects/shower-09-amazing.jpeg",
    alt: "Finished custom tile shower remodeling project"
  },
  {
    src: "/images/projects/bathroom-06-sinks-amazing.JPG",
    alt: "Finished bathroom vanity and sink remodeling project"
  },
  {
    src: "/images/projects/shower-11-great.jpeg",
    alt: "Custom tiled shower renovation"
  },
  {
    src: "/images/projects/shower-12-finished-with-glass-great.jpeg",
    alt: "Finished glass shower and tile renovation"
  },
  {
    src: "/images/projects/shower-14-amazing.JPG",
    alt: "Finished bathroom shower tile project"
  },
  {
    src: "/images/projects/shower-and-sink-16-good.jpeg",
    alt: "Bathroom remodel with shower and vanity"
  }
];

const craftsmanshipProjects = [
  {
    title: "Custom Shower Tile",
    text: "Careful tile placement, clean lines, and detailed finishing create a polished shower from wall to wall.",
    image: "/images/projects/shower-03-good.JPG"
  },
  {
    title: "Feature Wall Tile",
    text: "Tile layout and pattern choices can completely transform the appearance of a shower and bathroom.",
    image: "/images/projects/shower-07-wall-good.jpeg"
  },
  {
    title: "Built-In Shower Details",
    text: "Shelving, niches, edges, and transitions are finished with the same attention as the larger tiled surfaces.",
    image: "/images/projects/shower-05-shelf-good.JPG"
  }
];

const tileProjects = [
  {
    title: "Foyer Tile",
    text: "Tile installation is not limited to the bathroom. Entryways and other high-use areas can benefit from a durable tile finish.",
    image: "/images/projects/foyer-tile-04-good.JPG"
  },
  {
    title: "Kitchen Tile",
    text: "Detailed tile work can add a clean finished look around kitchen counters, cooking areas, and backsplashes.",
    image: "/images/projects/stovetop-kitchen-02-good.JPG"
  },
  {
    title: "Bathroom Wall Tile",
    text: "Large-format and decorative wall tile can create a distinctive finished look while keeping the space practical and durable.",
    image: "/images/projects/shower-13-wall.JPG"
  }
];

const drainageProjects = [
  {
    src: "/images/projects/shower-05-good-drainage-floor-picture.JPG",
    title: "Shower Floor & Drain Detail",
    text: "Careful tile layout and drainage details help create a clean finished shower floor."
  },
  {
    src: "/images/projects/shower-09-drainage.jpeg",
    title: "Integrated Drainage",
    text: "Thoughtful shower floor installation balances appearance, slope, and everyday function."
  },
  {
    src: "/images/projects/shower-12-drainage-good.jpeg",
    title: "Tile & Drain Finish",
    text: "Precision around drains and transitions is one of the details that separates a finished installation."
  }
];

const lightingProjects = [
  {
    title: "Vanity Lighting",
    text: "Thoughtful vanity lighting helps complete the finished bathroom while providing practical illumination around mirrors and sinks.",
    image: "/images/projects/sinks-08-lights-on-eh.JPG",
    position: "center"
  },
  {
    title: "Sink & Mirror Finishing",
    text: "Lighting, mirrors, fixtures, countertops, and tile work together to create a polished finished vanity area.",
    image: "/images/projects/sink-13-good.JPG",
    position: "top center"
  },
  {
    title: "Shower Lighting",
    text: "Lighting placement can highlight tile, glass, and shower details while helping the entire bathroom feel brighter and more open.",
    image: "/images/projects/shower-14-amazing.JPG",
    position: "center"
  },
  {
    title: "Double Vanity Details",
    text: "Finished vanity spaces combine cabinetry, sinks, mirrors, fixtures, lighting, and surrounding finishes into one cohesive design.",
    image: "/images/projects/bathroom-06-sinks-amazing.JPG",
    position: "center"
  },
  {
    title: "Bathroom Lighting Details",
    text: "The right fixtures and placement bring attention to the finished materials and help tie the entire renovation together.",
    image: "/images/projects/sinks-08-zoomed-out-good.jpeg",
    position: "center"
  }
];

const finishingProjects = [
  {
    title: "Vanities & Fixtures",
    text: "Bathroom remodeling includes the details around the tile, including vanities, sinks, mirrors, lighting, and fixtures.",
    image: "/images/projects/bathroom-15-wow-but-not-main.jpeg"
  },
  {
    title: "Finished Sink Areas",
    text: "Clean installation around sinks and countertops helps tie the entire bathroom design together.",
    image: "/images/projects/sink-13-good.JPG"
  },
  {
    title: "Complete Bathroom Spaces",
    text: "Each element is considered together so the shower, tile, fixtures, and surrounding finishes feel like one complete renovation.",
    image: "/images/projects/shower-09-shower-and-toiled-good.jpeg"
  }
];

const serviceAreas = [
  "Middlesex County",
  "Somerset County",
  "Union County",
  "Monmouth County",
  "Bridgewater",
  "Summit"
];

function App() {
  return (
    <div className="site">
      <header className="topbar">
        <div className="container topbar-inner">
          <span>Serving Central New Jersey</span>

          <a href={`tel:${PHONE_LINK}`}>
            Call or Text: {PHONE_DISPLAY}
          </a>
        </div>
      </header>

      <header className="main-header">
        <div className="container header-inner">
          <a
            className="brand"
            href="#home"
            aria-label="NH Tile and Remodeling home"
          >
            <div className="logo-placeholder">
              NH
            </div>

            <div className="brand-copy">
              <strong>
                NH Tile & Remodeling
              </strong>

              <span>
                Bathrooms • Tile • Renovation
              </span>
            </div>
          </a>

          <nav className="desktop-nav">
            <a href="#home">
              Home
            </a>

            <a href="#services">
              Services
            </a>

            <a href="#work">
              Bathrooms
            </a>

            <a href="#areas">
              Service Areas
            </a>

            <a href="#contact">
              Contact
            </a>
          </nav>

          <a
            className="header-cta"
            href="#contact"
          >
            Request a Quote
          </a>
        </div>
      </header>

      <main>
        <section
          className="hero"
          id="home"
          style={{
            backgroundImage:
              'linear-gradient(90deg, rgba(0, 29, 51, .86) 0%, rgba(0, 29, 51, .63) 48%, rgba(0,0,0,.18) 100%), url("/images/projects/shower-14-amazing.JPG")'
          }}
        >
          <div className="hero-overlay" />

          <div className="container hero-content">
            <div className="hero-copy">
              <span className="eyebrow">
                Bathroom Remodeling & Tile Specialists
              </span>

              <h1>
                Quality Bathroom Remodeling Built Around the Details
              </h1>

              <p>
                NH Tile & Remodeling provides professional bathroom
                renovations and custom tile installation throughout
                Middlesex, Somerset, Union, Monmouth, and surrounding
                areas.
              </p>

              <div className="hero-actions">
                <a
                  className="button primary"
                  href={`tel:${PHONE_LINK}`}
                >
                  Get a Free Estimate
                </a>

                <a
                  className="button secondary"
                  href={`sms:${PHONE_LINK}`}
                >
                  Text Us
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="trust-strip">
          <div className="container trust-grid">
            <div>
              <strong>Bathroom Focused</strong>
              <span>Specialized remodeling</span>
            </div>

            <div>
              <strong>Tile Expertise</strong>
              <span>Clean, precise installation</span>
            </div>

            <div>
              <strong>Local Service</strong>
              <span>Central New Jersey</span>
            </div>

            <div>
              <strong>Direct Contact</strong>
              <span>Work directly with NH</span>
            </div>
          </div>
        </section>

        <section className="section intro">
          <div className="container split">
            <div>
              <span className="eyebrow">
                NH Tile & Remodeling
              </span>

              <h2>
                Bathrooms and Tile. Done Right.
              </h2>

              <p className="lead">
                We keep our focus where our experience is strongest:
                bathroom remodeling and tile work. From a full bathroom
                renovation to a custom shower or new tile floor, every
                project is approached with careful planning, quality
                workmanship, and attention to detail.
              </p>

              <p>
                Based in Middlesex County and serving homeowners across
                Central New Jersey, NH Tile & Remodeling delivers a
                straightforward remodeling experience with direct
                communication from start to finish.
              </p>

              <a
                className="text-link"
                href="#services"
              >
                Explore our services →
              </a>
            </div>

            <div className="intro-image-card">
              <div
                className="image-placeholder"
                role="img"
                aria-label="Finished custom shower tile project"
                style={{
                  backgroundImage:
                    'linear-gradient(135deg, rgba(11,61,104,.08), rgba(23,79,124,.03)), url("/images/projects/shower-03-good.JPG")',
                  backgroundSize: "cover",
                  backgroundPosition: "center"
                }}
              />

              <div className="accent-card">
                <strong>
                  Built for local homeowners
                </strong>

                <span>
                  Middlesex • Somerset • Union • Monmouth
                </span>
              </div>
            </div>
          </div>
        </section>

        <section
          className="section services-section"
          id="services"
        >
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                What We Do
              </span>

              <h2>
                Bathroom Remodeling & Tile Services
              </h2>

              <p>
                Focused services for homeowners looking to improve
                their bathrooms with quality tile work and careful
                finishing.
              </p>
            </div>

            <div className="service-grid">
              {services.map((service) => (
                <article
                  className="service-card"
                  key={service.title}
                >
                  <div
                    className="service-image"
                    style={{
                      backgroundImage: `url("${service.image}")`
                    }}
                    role="img"
                    aria-label={service.title}
                  />

                  <div className="service-content">
                    <h3>{service.title}</h3>

                    <p>{service.text}</p>

                    <a href={`tel:${PHONE_LINK}`}>
                      Request an estimate
                    </a>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section
          className="section work-section"
          id="work"
        >
          <div className="container">
            <div className="section-heading heading-row">
              <div>
                <span className="eyebrow">
                  Recent Work
                </span>

                <h2>
                  Bathroom & Tile Projects
                </h2>

                <p>
                  Real completed projects from homes throughout the area.
                </p>
              </div>

              <a
                className="button outline"
                href={`tel:${PHONE_LINK}`}
              >
                Start Your Project
              </a>
            </div>

            <div className="gallery-grid">
              {galleryProjects.map((project) => (
                <figure
                  className="gallery-item"
                  key={project.src}
                >
                  <img
                    src={project.src}
                    alt={project.alt}
                    loading="lazy"
                  />
                </figure>
              ))}
            </div>
          </div>
        </section>

        <section className="section services-section">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                Craftsmanship Up Close
              </span>

              <h2>
                The Details That Finish a Shower
              </h2>

              <p>
                Great tile work is not only about the overall room.
                Corners, niches, shelves, transitions, and individual
                tile lines all contribute to the finished result.
              </p>
            </div>

            <div className="service-grid">
              {craftsmanshipProjects.map((project) => (
                <article
                  className="service-card"
                  key={project.title}
                >
                  <div
                    className="service-image"
                    style={{
                      backgroundImage: `url("${project.image}")`
                    }}
                    role="img"
                    aria-label={project.title}
                  />

                  <div className="service-content">
                    <h3>{project.title}</h3>
                    <p>{project.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                More Than Showers
              </span>

              <h2>
                Tile Work Throughout the Home
              </h2>

              <p>
                NH Tile & Remodeling also handles tile applications
                outside the shower, including floors, walls, entryways,
                and kitchen tile work.
              </p>
            </div>

            <div className="service-grid">
              {tileProjects.map((project) => (
                <article
                  className="service-card"
                  key={project.title}
                >
                  <div
                    className="service-image"
                    style={{
                      backgroundImage: `url("${project.image}")`
                    }}
                    role="img"
                    aria-label={project.title}
                  />

                  <div className="service-content">
                    <h3>{project.title}</h3>
                    <p>{project.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section
          className="section services-section"
          id="drainage"
        >
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                The Details Matter
              </span>

              <h2>
                Shower Drainage & Floor Details
              </h2>

              <p>
                A finished shower is about more than the wall tile.
                Proper floor layout, transitions, drainage, and clean
                detail work all contribute to the final result.
              </p>
            </div>

            <div className="service-grid">
              {drainageProjects.map((project) => (
                <article
                  className="service-card"
                  key={project.src}
                >
                  <div
                    className="service-image"
                    role="img"
                    aria-label={project.title}
                    style={{
                      backgroundImage: `url("${project.src}")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center"
                    }}
                  />

                  <div className="service-content">
                    <h3>{project.title}</h3>
                    <p>{project.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section
          className="section"
          id="lighting"
        >
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                Lighting & Finishing Details
              </span>

              <h2>
                Lighting That Completes the Bathroom
              </h2>

              <p>
                Lighting is an important part of the finished space.
                Vanity fixtures, mirrors, shower lighting, tile, and
                surrounding finishes all work together to give the
                bathroom its final look.
              </p>
            </div>

            <div className="service-grid">
              {lightingProjects.map((project) => (
                <article
                  className="service-card"
                  key={project.title}
                >
                  <div
                    className="service-image"
                    style={{
                      backgroundImage: `url("${project.image}")`,
                      backgroundPosition:
                        project.position || "center"
                    }}
                    role="img"
                    aria-label={project.title}
                  />

                  <div className="service-content">
                    <h3>{project.title}</h3>
                    <p>{project.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section className="section services-section">
          <div className="container">
            <div className="section-heading">
              <span className="eyebrow">
                Complete Renovations
              </span>

              <h2>
                Finishing the Entire Bathroom
              </h2>

              <p>
                The tile may be the centerpiece, but the finished
                bathroom comes together through vanities, sinks,
                fixtures, mirrors, lighting, and the surrounding
                details.
              </p>
            </div>

            <div className="service-grid">
              {finishingProjects.map((project) => (
                <article
                  className="service-card"
                  key={project.title}
                >
                  <div
                    className="service-image"
                    style={{
                      backgroundImage: `url("${project.image}")`
                    }}
                    role="img"
                    aria-label={project.title}
                  />

                  <div className="service-content">
                    <h3>{project.title}</h3>
                    <p>{project.text}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>

        <section
          className="section areas-section"
          id="areas"
        >
          <div className="container split areas-split">
            <div>
              <span className="eyebrow">
                Service Areas
              </span>

              <h2>
                Serving Central New Jersey
              </h2>

              <p className="lead">
                NH Tile & Remodeling is based in Middlesex County
                and works throughout nearby communities for bathroom
                remodeling and tile projects.
              </p>

              <div className="area-list">
                {serviceAreas.map((area) => (
                  <span key={area}>
                    {area}
                  </span>
                ))}
              </div>
            </div>

            <div className="area-panel">
              <span className="mini-label">
                LOCAL REMODELING
              </span>

              <h3>
                Looking for a bathroom remodeler near you?
              </h3>

              <p>
                Call or text to discuss your project and location.
                NH Tile & Remodeling will let you know about
                availability and next steps.
              </p>

              <a
                className="button primary"
                href={`tel:${PHONE_LINK}`}
              >
                Call {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </section>

        <section
          className="section contact-section"
          id="contact"
        >
          <div className="container contact-grid">
            <div className="contact-copy">
              <span className="eyebrow light">
                Request an Estimate
              </span>

              <h2>
                Ready to Talk About Your Bathroom or Tile Project?
              </h2>

              <p>
                Call or text NH Tile & Remodeling directly to discuss
                your project, location, and what you are looking to have
                done.
              </p>

              <div className="contact-direct">
                <span>
                  Project inquiries
                </span>

                <a href={`tel:${PHONE_LINK}`}>
                  {PHONE_DISPLAY}
                </a>
              </div>

              <div
                className="contact-direct"
                style={{
                  marginTop: "26px"
                }}
              >
                <span>
                  Scheduling Coordinator — {COORDINATOR_NAME}
                </span>

                <a href={`tel:${COORDINATOR_PHONE_LINK}`}>
                  {COORDINATOR_PHONE_DISPLAY}
                </a>

                <a
                  href={`mailto:${COORDINATOR_EMAIL}`}
                  style={{
                    marginTop: "6px",
                    fontSize: "16px"
                  }}
                >
                  {COORDINATOR_EMAIL}
                </a>
              </div>
            </div>

            <div className="contact-form">
              <span className="eyebrow">
                Get Started
              </span>

              <h3
                style={{
                  margin: 0,
                  fontSize: "30px",
                  lineHeight: "1.15"
                }}
              >
                Let's Discuss Your Project
              </h3>

              <p
                style={{
                  margin: 0,
                  color: "var(--muted)",
                  fontSize: "16px"
                }}
              >
                Have a bathroom renovation or tile project in mind?
                Reach out directly for an estimate, or contact Cristina
                for scheduling and coordination.
              </p>

              <a
                className="button primary full"
                href={`tel:${PHONE_LINK}`}
              >
                Call {PHONE_DISPLAY}
              </a>

              <a
                className="button outline full"
                href={`sms:${PHONE_LINK}`}
              >
                Text NH Tile & Remodeling
              </a>

              <div
                style={{
                  marginTop: "10px",
                  paddingTop: "22px",
                  borderTop: "1px solid var(--border)"
                }}
              >
                <span
                  className="mini-label"
                  style={{
                    display: "block",
                    marginBottom: "7px"
                  }}
                >
                  SCHEDULING & COORDINATION
                </span>

                <h3
                  style={{
                    margin: "0 0 8px",
                    fontSize: "21px"
                  }}
                >
                  Contact Cristina
                </h3>

                <p
                  style={{
                    margin: "0 0 18px",
                    color: "var(--muted)",
                    fontSize: "14px"
                  }}
                >
                  For scheduling or coordinating your project,
                  Cristina can also be reached directly by phone
                  or email.
                </p>

                <a
                  className="button outline full"
                  href={`tel:${COORDINATOR_PHONE_LINK}`}
                >
                  Call Cristina: {COORDINATOR_PHONE_DISPLAY}
                </a>

                <a
                  className="button outline full"
                  href={`mailto:${COORDINATOR_EMAIL}`}
                  style={{
                    marginTop: "10px"
                  }}
                >
                  Email Cristina
                </a>
              </div>

              <small>
                Serving Middlesex County and surrounding Central
                New Jersey communities.
              </small>
            </div>
          </div>
        </section>
      </main>

      <footer>
        <div className="container footer-grid">
          <div>
            <strong>
              NH Tile & Remodeling
            </strong>

            <p>
              Bathroom remodeling and tile installation in
              Central New Jersey.
            </p>
          </div>

          <div>
            <span>
              Service Areas
            </span>

            <p>
              Middlesex • Somerset • Union • Monmouth
            </p>
          </div>

          <div>
            <span>
              Contact
            </span>

            <p
              style={{
                marginBottom: "4px"
              }}
            >
              Project Inquiries
            </p>

            <a href={`tel:${PHONE_LINK}`}>
              {PHONE_DISPLAY}
            </a>

            <a href={`mailto:${EMAIL}`}>
              {EMAIL}
            </a>

            <p
              style={{
                marginTop: "20px",
                marginBottom: "4px"
              }}
            >
              Cristina — Scheduling Coordinator
            </p>

            <a href={`tel:${COORDINATOR_PHONE_LINK}`}>
              {COORDINATOR_PHONE_DISPLAY}
            </a>

            <a href={`mailto:${COORDINATOR_EMAIL}`}>
              {COORDINATOR_EMAIL}
            </a>
          </div>
        </div>

        <div className="container footer-bottom">
          © {new Date().getFullYear()} NH Tile & Remodeling.
          All rights reserved.
        </div>
      </footer>

      <div className="mobile-contact-bar">
        <a href={`tel:${PHONE_LINK}`}>
          Call
        </a>

        <a href={`sms:${PHONE_LINK}`}>
          Text
        </a>
      </div>
    </div>
  );
}

export default App;